const numberWithOneDotParser = value => {
    if((value.match(/\./g) || []).length > 1) {
        value = value.slice(0, -1)
    };
    return value.replace(/[a-zA-Z]/g, '')
}


export default numberWithOneDotParser